import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'app/app.component';
import { CategoriesSerializer } from 'app/pages/categories/categories.serializer';
import { CategoryService } from 'app/services/category/category.service';
@Component({
  selector: 'ultra-category-menu',
  templateUrl: './category-menu.component.html',
  styleUrls: ['./category-menu.component.scss'],
})
export class CategoryMenuComponent implements OnInit {
  @Input()
  menu: any[] = [];

  @Input()
  isSubMenu: boolean = false;

  @Input()
  isScrollable: boolean = false;

  @Input()
  index?: number;

  constructor(
    private _categoryService: CategoryService,
    private router: Router,
  ) {
    AppComponent.quantityElements++;
  }

  enterMouse() {

    const menu = document.getElementById('menu');
    const categoryList = document.getElementById('category-list');
    const subCategoryList = document.getElementById('sub-category-list-' + this.index);
    const limit = menu.style.transform.replace(/\D/g, "");

    if ((subCategoryList.clientHeight + Number(limit)) > categoryList.clientHeight) {
      AppComponent.lastPosition = menu.style.transform;
      AppComponent.index = this.index;
    }
  }

  leaveMouse() {
    const containers = document.getElementById('menu');

    if (AppComponent.index) {
      containers.style.transform = AppComponent.lastPosition;
      AppComponent.categoryOrientationY = Number(AppComponent.lastPosition.replace('translateY(', "").replace('px)', ''));
    }

    AppComponent.index = undefined;
  }

  ngOnInit(): void {
    if ((!this.menu || this.menu.length === 0))
      this._categoryService.findAll().subscribe((value) => {
        this.menu = this._categoryService.buildMenu(value.data.map(e => CategoriesSerializer.fromJson(e)));
      });
  }

  navigateCategory(item) {
    this.router.navigate(['pages/products'],
      item.queryParams && item.queryParams !== null ? { queryParams: { category: item.queryParams.category } } : undefined);
  }
}
